import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonModal from 'components/elements/modals/CommonModal';
import TwoFactorCode from 'components/dashboard/security-content/TwoFactorCode';
import TwoFactorConfirmation from 'components/dashboard/security-content/TwoFactorConfirmation';

import './TwoFactorAuthenticationModal.css';

function TwoFactorAuthenticationModal(props) {
  const { open, onClose } = props;
  const [activeStep, setActiveStep] = useState('code');
  const { t } = useTranslation();

  const onModalClose = () => {
    setActiveStep('code');
    onClose();
  };

  return (
    <CommonModal
      className="two-factor-authentication-modal__component"
      open={open}
      onClose={onModalClose}
    >
      <div className="header">{t("Two Factor Authentication")}</div>

      <div className="content-wrapper">
        {activeStep === 'code' &&
          <TwoFactorCode
            onClose={onModalClose}
            setActiveStep={setActiveStep}
          />
        }

        {activeStep === 'confirmation' &&
          <TwoFactorConfirmation
            onClose={onModalClose}
            setActiveStep={setActiveStep}
          />
        }
      </div>
    </CommonModal>
  );
}

TwoFactorAuthenticationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

TwoFactorAuthenticationModal.defaultProps = {
  open: null,
};

export default TwoFactorAuthenticationModal;
